(function () {
  if ($pdk && $pdk.controller && $pdk.controller.plugInLoaded) {
    var youboraPlugin = function () {
      var VERSION = "1.0"

      /**
       * Initialize the plugin with the load object
       * @param lo load object
       */
      function initialize (lo) {
        if (lo.vars.accountCode) {
          var options = { accountCode: lo.vars.accountCode }
          if (lo.vars.extraparams) {
            var paramlist = lo.vars.extraparams.split(',')
            for (var i = 0; i < paramlist.length; i++) {
              options['param' + (i + 1)] = paramlist[i]
            }
          }
          window.youboraAnalytics = new youbora.Plugin(options)
          youboraAnalytics.setAdapter(new youbora.adapters.ThePlatform(lo.controller))
        }
      }
      this.initialize = initialize
    }
    $pdk.controller.plugInLoaded(new youboraPlugin(), null)
  }
})();
